var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFintech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6289 21.4131V15.2353L16.2383 13.2134V6.23438",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4941 21.4136V16.7423L27.8847 14.7204V6.46289",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 21.4132V15.4738L25.2265 14.0323V8.70898",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 21.4132V15.4738L25.2265 14.0323V8.70898",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.289 21.4132V15.4738L18.8984 14.0323V8.70898",
    fill: "#F48000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.289 21.4132V15.4738L18.8984 14.0323V8.70898",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0039 21.4129V10.2207",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6289 34.0556V40.2334L16.2383 42.2554V49.2344",
    fill: "#F48000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6289 34.0556V40.2334L16.2383 42.2554V49.2344",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4941 34.0552V38.7264L27.8847 40.7483V49.0059",
    fill: "#F48000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4941 34.0552V38.7264L27.8847 40.7483V49.0059",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 34.0556V39.995L25.2265 41.4364V46.7598",
    fill: "#F48000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 34.0556V39.995L25.2265 41.4364V46.7598",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.289 34.0556V39.995L18.8984 41.4364V46.7598",
    fill: "#F48000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.289 34.0556V39.995L18.8984 41.4364V46.7598",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0039 34.0559V45.248",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7109 23.8549H33.8893L35.9112 22.4648H42.8907",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7109 31.6924H32.3827L34.4036 33.083H42.6607",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7109 29.3857H33.6503L35.0923 30.7758H40.4151",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7109 26.1615H33.6503L35.0923 24.7725H40.4151",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7129 27.7734H38.9056",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 23.8549H10.0751L8.05421 22.4648H1.07422",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2525 31.6924H11.5807L9.55976 33.083H1.30273",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 29.3857H10.3156L8.87169 30.7758H3.54883",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 26.1615H10.3156L8.87169 24.7725H3.54883",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2542 27.7734H5.0625",
    stroke: "#F48000",
    strokeWidth: 1.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5221 38.1626C37.5221 40.9906 35.2298 43.2836 32.4018 43.2836H11.6222C8.79421 43.2836 6.50195 40.9906 6.50195 38.1626V17.3837C6.50195 14.555 8.79421 12.2627 11.6222 12.2627H32.4018C35.2298 12.2627 37.5221 14.555 37.5221 17.3837V38.1626Z",
    fill: "#F48000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6449 28.7526C29.0642 28.0304 28.1547 27.5207 26.922 27.2244C27.7335 26.9423 28.3499 26.5607 28.7742 26.0763C29.4039 25.3494 29.7208 24.4786 29.7208 23.4633C29.7208 22.2535 29.2783 21.2389 28.3902 20.4196C27.7114 19.7906 26.8051 19.405 25.6775 19.2572V17.6982H23.8033V19.1893H21.88V17.6982H20.0058V19.1893H14.6445V36.361H20.0058V37.8521H21.88V36.361H23.8033V37.8521H25.6775V36.1912C25.8348 36.1714 26.0047 36.1509 26.184 36.1271C27.0793 36.0094 27.7533 35.8214 28.1974 35.5646C28.9164 35.1505 29.4845 34.5887 29.897 33.8784C30.311 33.1672 30.5181 32.3668 30.5181 31.4763C30.5181 30.3835 30.2265 29.4756 29.6449 28.7534V28.7526ZM19.9987 22.6676H22.3399C23.1467 22.6676 23.71 22.8082 24.0316 23.0887C24.3588 23.37 24.5184 23.7604 24.5184 24.2597C24.5184 24.7986 24.3588 25.2111 24.0316 25.4963C23.7093 25.7816 23.134 25.923 22.3028 25.923H19.9979V22.6676H19.9987ZM19.9987 32.671V29.1919H22.6915C23.6223 29.1919 24.2726 29.346 24.6416 29.6549C25.013 29.9639 25.1971 30.3716 25.1971 30.8789C25.1971 31.4257 25.0106 31.8619 24.6361 32.1858C24.2608 32.5098 23.6168 32.6718 22.7057 32.6718H19.9979L19.9987 32.671Z",
    fill: "#FFE4C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintech);
export default __webpack_public_path__ + "static/media/Fintech.21afea473a5e072e50c612737471a1a0.svg";
export { ForwardRef as ReactComponent };